









import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Badge } from '@/components/Base';

@Component({
  components: {
    Badge,
  },
})
export default class ProductCategoryHeader extends Vue {
  @Prop() public categoryTitle: string;
  @Prop() public totalItems: number;
  @Prop() public areAllItemsFetched: boolean;

  @Emit('get-products')
  public showProducts() {
    return true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProductCategory/ProductCategoryHeader/ProductCategoryHeader.vue